import { ValorationResponse } from "@app/interface/valoration.response";
import { createReducer, on } from "@ngrx/store";
import * as PRAGMAPOWERS from '../../utils/mocks/valoration.mock';
import { AUTO_VALORATION_INIT } from '../../utils/mocks/auto-valoration.response.mock';
import { AutoValorationActions } from "./auto-valoration.action.types";
import { PragmaPowerCategory } from "@app/interface/pragma-power-categories.interface";
import { PragmaPowerDefinition } from "@app/interface/pragma-power-definition.interface";
import { PragmaPowerScores, Score } from "@app/interface/pragma-power-scores-interface";
import { PragmaPowerBehaviorDefinition } from "@app/interface/pragma-power-behavior.interface";
import { AssessmentPragmaPower } from "@app/interface/assesment-pragmapower";

export const initialValoration: ValorationResponse = AUTO_VALORATION_INIT;
export const initialPragmaPowersCategories: PragmaPowerCategory[] = PRAGMAPOWERS.PRAGMAPOWERS_CATEGORIES_INIT;
export const initialPragmaPowerDefinition: PragmaPowerDefinition[] = PRAGMAPOWERS.PRAGMAPOWER_DEFINITION_INIT;
export const initialPragmaPowerBehaviorDefinition: PragmaPowerBehaviorDefinition[] = [];
export const initialPragmaPowerScores: PragmaPowerScores[] = [];
export const initialPragmaPowerScoresSelected: Score[] = [];
export const initialSelfAssessmentPragmaPowerDefinition: AssessmentPragmaPower[] = [];

export interface HomeAutoValorationState {
  autoValorationMapGeneral: boolean,
  valoration: ValorationResponse,
  pragmaPowerCategories: PragmaPowerCategory[],
  pragmaPowerDefinition: PragmaPowerDefinition[],
  pragmaPowerScores: PragmaPowerScores[],
  pragmaPowerBehaviorDefinition: PragmaPowerBehaviorDefinition[],
  score: Score[],
  selectedScoreIds: number[],
  firstPragmaPowerDefinition: PragmaPowerDefinition | null;
  selfAssessmentPragmaPowerDefinition: AssessmentPragmaPower[],
  selfAssessmentPragmaPowerDefinitionLoaded: boolean,
  allpragmaPowerBehaviorDefinitions: PragmaPowerBehaviorDefinition[],
  allPragmaPowerBehaviorDefinitionsLoaded: boolean,
  allPragmaPowerDefinition: PragmaPowerDefinition[],
  allPragmaPowerDefinitionsLoaded: boolean,
}

export const initialHomeAutoValoration: HomeAutoValorationState = {
  autoValorationMapGeneral: false,
  valoration: initialValoration,
  pragmaPowerCategories: initialPragmaPowersCategories,
  pragmaPowerDefinition: initialPragmaPowerDefinition,
  pragmaPowerScores: initialPragmaPowerScores,
  pragmaPowerBehaviorDefinition: initialPragmaPowerBehaviorDefinition,
  score: initialPragmaPowerScoresSelected,
  selectedScoreIds: [],
  firstPragmaPowerDefinition: null,
  selfAssessmentPragmaPowerDefinition: initialSelfAssessmentPragmaPowerDefinition,
  selfAssessmentPragmaPowerDefinitionLoaded: false,
  allpragmaPowerBehaviorDefinitions: initialPragmaPowerBehaviorDefinition,
  allPragmaPowerBehaviorDefinitionsLoaded: false,
  allPragmaPowerDefinition: [],
  allPragmaPowerDefinitionsLoaded: false
}

export const HomeAutoValorationReducer = createReducer(
  initialHomeAutoValoration,
  on(AutoValorationActions.loadStateByAutoValorationMap, (state, action): HomeAutoValorationState => {
    return {
      ...state,
      autoValorationMapGeneral: action.autoValorationMapGeneral,
    };
  }),
  on(AutoValorationActions.loadAutoValorationDefinitionsSuccess,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        valoration: action.valoration
      }
    }),
  on(AutoValorationActions.loadPragmaPowerCategoriesSuccess,
    (state, action): HomeAutoValorationState => {
      const pragmaPowerCategoriesWithState = action.pragmaPowerCategories.map(category => ({
        ...category,
        state: 'not-started'
      }));
      return {
        ...state,
        pragmaPowerCategories: pragmaPowerCategoriesWithState
      };
    }),
  on(AutoValorationActions.updatePragmaPowerCategoryState, (state, action) => {
    const updatedCategories = state.pragmaPowerCategories.map(category => {
      if (category.id === action.idCategory) {
        return {
          ...category,
          state: action.newState
        };
      }
      return category;
    });

    return {
      ...state,
      pragmaPowerCategories: updatedCategories
    };
  }),

  on(AutoValorationActions.loadPragmaPowerDefinitionSuccess,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        pragmaPowerDefinition: action.pragmaPowerDefinition,
        firstPragmaPowerDefinition: action.pragmaPowerDefinition.length > 0 ? action.pragmaPowerDefinition[0] : null,
      }
    }),
  on(AutoValorationActions.loadAllPragmaPowerDefinitions,
    (state, action): HomeAutoValorationState => {
      //const allDefinitionsSet = new Set([...state.allPragmaPowerDefinition, ...action.pragmaPowerDefinition]);

      // Crear un nuevo conjunto de definiciones
      const allDefinitionsSet = new Set(state.allPragmaPowerDefinition);

      // Iterar sobre las definiciones proporcionadas en la acción
      action.pragmaPowerDefinition.forEach(definition => {
        // Verificar si ya existe una definición con el mismo ID
        const existingDefinitionIndex = state.allPragmaPowerDefinition.findIndex(d => d.id === definition.id);
        if (existingDefinitionIndex !== -1) {
          // Si existe, reemplazar la definición existente con la nueva
          allDefinitionsSet.delete(state.allPragmaPowerDefinition[existingDefinitionIndex]);
        }
        // Agregar la nueva definición
        allDefinitionsSet.add(definition);
      });
      return {
        ...state,
        allPragmaPowerDefinition: Array.from(allDefinitionsSet),
      }
    }
  ),
  on(AutoValorationActions.allPragmaPowerDefinitionsLoaded,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        allPragmaPowerDefinitionsLoaded: action.isLoaded
      }
    }),
  on(AutoValorationActions.loadPragmaPowersBehaviorsDefinitionSuccess,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        pragmaPowerBehaviorDefinition: action.pragmaPowerBehaviorDefinition
      }
    }),
  on(AutoValorationActions.loadPragmaPowerScoresSuccess,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        pragmaPowerScores: action.pragmaPowerScores
      }
    }),
  on(AutoValorationActions.savePragmaPowerScore,
    (state, action): HomeAutoValorationState => {
      const existingScore = state.score.find(score => score.id === action.score.id);
      if (existingScore) {
        return {
          ...state,
          score: state.score.map(score =>
            score.id === action.score.id ? { ...score, scoreId: action.score.scoreId, openEndedReply: action.score.openEndedReply } : score

          ),
        };
      } else {
        return {
          ...state,
          score: [...state.score, action.score],
          selectedScoreIds: [...state.selectedScoreIds, action.score.id]
        };
      }
    }
  ),
  on(AutoValorationActions.savePragmaPowerScores,
    (state, action): HomeAutoValorationState => {
      const newScores = action.scores.filter(newScore =>
        !state.score.some(existingScore => existingScore.id === newScore.id)
      );
      return {
        ...state,
        score: [...state.score, ...newScores]
      }
    }
  ),
  on(AutoValorationActions.setPragmaPowerBehaviorsSelected,
    (state): HomeAutoValorationState => {
      const selectedDefinitions = state.allpragmaPowerBehaviorDefinitions.filter(
        definition => state.selectedScoreIds.includes(definition.id)
      );
      const allpragmaPowerBehaviorDefinitions = state.allpragmaPowerBehaviorDefinitions.map(definition => ({
        ...definition,
        selected: selectedDefinitions.some(selectedDefinition => selectedDefinition.id === definition.id)
      }));
      return {
        ...state,
        allpragmaPowerBehaviorDefinitions
      };
    }
  ),
  on(AutoValorationActions.loadSelfAssessmentPragmaPowerDefinitionsSuccess,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        selfAssessmentPragmaPowerDefinition: action.assessmentPragmaPower,
        selfAssessmentPragmaPowerDefinitionLoaded: true
      }
    }
  ),
  on(AutoValorationActions.loadAllPragmaPowerBehaviorsDefinitions,
    (state, action): HomeAutoValorationState => {
      const allDefinitionsSet = new Set([...state.allpragmaPowerBehaviorDefinitions, ...action.pragmaPowerBehaviorDefinition]);
      return {
        ...state,
        allpragmaPowerBehaviorDefinitions: Array.from(allDefinitionsSet),
      }
    }
  ),
  on(AutoValorationActions.allBehaviorsDefinitionsLoaded,
    (state, action): HomeAutoValorationState => {
      return {
        ...state,
        allPragmaPowerBehaviorDefinitionsLoaded: action.isLoaded
      }
    }),
  on(AutoValorationActions.clearPragmaPowerScores,
    (state): HomeAutoValorationState => {
      return {
        ...state,
        score: [],
        selectedScoreIds: []
      };
    }
  ),
  on(AutoValorationActions.resetAutoValorationState,
    (): HomeAutoValorationState => {
      return initialHomeAutoValoration;
    }
  )

)